@if (!isCustomFieldsLoaded) {
  <div class="personal-information-ghost-wrapper cbcw-personal-information-ghost-wrapper">
    @for (item of [0, 1, 2, 3, 4, 5]; track item) {
      <div class="personal-information-ghost skeleton-animation cbcw-personal-information-ghost">
        <div class="bar bar-{{ item }}"></div>
      </div>
    }
  </div>
}

@if (isCustomFieldsLoaded) {
  <div class="personal-information-wrapper data-container cbcw-personal-information-wrapper">
    <app-customer-form
      [index]="1"
      [customerRequiredFields]="defaultRequiredCustomerFields"
      [customerFormFields]="defaultCustomerFields"
      [userState]="userState"
      [globals]="globals"
      [partner]="partner"
      [userDataLSNameKey]="userDataLSNameKey"
      [widgetTemplates]="widgetTemplates"
      [type]="appointmentConstant.APPOINTMENT"
      [lang]="lang"
      [meetingTypes]="meetingTypes"
      [appointmentCart]="appointmentCart"
      [notificationTypes]="NOTIFICATION_TYPES"
      [showBeforeCustomField]="customersService?.customFieldsBefore?.length > 0"
      [showAfterCustomField]="customersService?.customFieldsAfter?.length > 0"
      [appointmentState]="appointmentState"
      [stores]="store"
      [lockedZip]="storeSearchZipCode"
    >
      <app-customfields
        beforeCustomField
        [widgetType]="widgetType"
        [(userState)]="userState"
        [globals]="globals"
        [customFields]="customersService.customFieldsBefore"
        [partner]="partner"
        [(customFieldValues)]="customFieldValues"
        [customFieldValuesLSNameKey]="customFieldValuesLSNameKey"
        [selectedJsonCustomFields]="selectedJsonCustomFields"
        [lang]="lang"
        [widgetTemplates]="widgetTemplates"
      />
      <app-customfields
        afterCustomField
        [widgetType]="widgetType"
        [(userState)]="userState"
        [globals]="globals"
        [customFields]="customersService.customFieldsAfter"
        [partner]="partner"
        [(customFieldValues)]="customFieldValues"
        [customFieldValuesLSNameKey]="customFieldValuesLSNameKey"
        [selectedJsonCustomFields]="selectedJsonCustomFields"
        [lang]="lang"
        [widgetTemplates]="widgetTemplates"
      />
    </app-customer-form>
  </div>
}
